// @flow
import { ActionHelper } from 'modules/helper';

const actionTypePrefix = 'ShibaniKamalArchitects/';
export const ArchitectsActionTypes = {
  GALLERY: ActionHelper.createActionTypes(actionTypePrefix, 'GALLERY'),
  PROJECT_OVERLAY: ActionHelper.createActionTypes(
    actionTypePrefix,
    'PROJECT_OVERLAY'
  ),
};
